import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Divider,Typography } from '@mui/material';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import { useContext,useEffect } from 'react';
import { WebFormContext } from '../../../context/WebFormContext';
import { ItemFormFilling } from '../../../types/new-form-filling/types';
import CheckIconItemComp from '../CheckIconItemComp';


export default function DrawerList({
  itens,
  setOpen,
  setItemToShow,
}: {
  itens: ItemFormFilling[]
  setOpen: Function
  setItemToShow: Function,
}) {
  const { ForceUpdate, webForm } = useContext(WebFormContext);

  useEffect(() => {
    ForceUpdate();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [webForm]);

  return (
    <Box sx={{ width: 300, paddingLeft: '10px' }} role="presentation" onClick={() => setOpen(false)}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ marginRight: '10px' }}
      >
        <Typography style={{ marginTop: '5px' }} variant='h6'>Itens:</Typography><ArrowBackIosNewIcon />
      </Stack>
      <List>
        {itens?.map((item, index) => (
          <>
            <ListItem key={index} disablePadding onClick={() => { setItemToShow(index); window.scrollTo(0, 0); }}>
              <ListItemButton>
                <Stack
                  width={'100%'}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <ListItemText primary={item.nome} />
                  <ListItemIcon>
                    <CheckIconItemComp item={item} />
                  </ListItemIcon>
                </Stack>
              </ListItemButton>
            </ListItem>
            <Divider />
          </>
        ))}
      </List>
    </Box>
  );
}
